import { render } from "./sidepane-communication-empty.vue?vue&type=template&id=3faeda7b"
import script from "./sidepane-communication-empty.vue?vue&type=script&lang=js"
export * from "./sidepane-communication-empty.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__